import { render, staticRenderFns } from "./cutout.vue?vue&type=template&id=4afc3a1e&scoped=true"
import script from "./cutout.vue?vue&type=script&lang=js"
export * from "./cutout.vue?vue&type=script&lang=js"
import style0 from "./cutout.vue?vue&type=style&index=0&id=4afc3a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc3a1e",
  null
  
)

export default component.exports